module.exports = __webpack_public_path__ + "static/img/ic_menu2.ce42f32a.png";